<template>
    <kiosk-group-details :teamId="props.teamId" :groupId="props.groupId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <div class="max-w-(--breakpoint-sm) flex flex-col">
                <page-callout section="kiosk-group-proforma-invoices" class="mb-4" />

                <page-loading v-if="loading || !billing"></page-loading>
                <template v-else>
                    <group-proforma-invoices
                        v-if="group.is_billable"
                        :teamId="props.teamId"
                        :groupId="group.group_id"
                        :paymentTermsDays="billing.payment_terms_days"
                    />
                </template>
            </div>
        </div>
    </kiosk-group-details>
</template>

<script setup>
import GroupProformaInvoices from '~/components/settings/billing/GroupProformaInvoices.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import PageCallout from '~/components/general/PageCallout.vue';
import KioskGroupDetails from '~/components/kiosk/kiosk-groups/details/KioskGroupDetails.vue';
import { useGroupDetails } from '~/components/kiosk/kiosk-groups/composables/useGroupDetails';

const props = defineProps({
    teamId: { type: Number, required: true },
    groupId: { type: String, required: true },
});

const { group, loading, billing, getBilling, onMountedGroup } = useGroupDetails();

onMountedGroup(() => {
    getBilling();
});
</script>
